exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-datepicker {\n  border: none !important;\n  border-bottom: 1px solid #455769 !important;\n  font-size: 10pt !important;\n}\n.table-datepicker-wrapper {\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a5b31004","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/misc/datatable/Datatable.vue
// module id = 687
// module chunks = 1